import { createDataStore } from "../lib/data_store";

const customerIdStore = createDataStore<string | undefined>();

export const useCustomerId = customerIdStore.useData;
export const setCustomerId = customerIdStore.setData;
